import { ApiTabIndex } from '@/Enums/ReportingDashboard/ApiTabIndex.enum';
import { IParsedAdvertiser } from '@/Interfaces/Advertiser.interface';
import { IReportingFilterModel } from '@/Interfaces/Filters/FilterModel.interface';
import { getDefaultFilter } from '@/helpers/reportingDashboard';
import { createSlice } from '@reduxjs/toolkit';

interface IState {
  apiTab: null | ApiTabIndex;
  filters: IReportingFilterModel<IParsedAdvertiser>;
  storedFilters: IReportingFilterModel<IParsedAdvertiser>;
  storedFiltersApi: null | ApiTabIndex;
}

const initialState: IState = {
  apiTab: null,
  filters: getDefaultFilter(),
  storedFilters: getDefaultFilter(),
  storedFiltersApi: null,
};

export const reportingDashboardSlice = createSlice({
  name: 'reportingDashboard',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      const newFilters = {
        ...state.filters,
        ...action.payload,
      };
      state.filters = newFilters;
      state.storedFiltersApi = state.apiTab;
      state.storedFilters = { ...newFilters };
    },
    resetFilters: state => {
      const defaultFilters = getDefaultFilter();
      state.filters = defaultFilters;
      state.storedFilters = defaultFilters;
    },
    setInitialApiTab: (state, action) => {
      state.apiTab = action.payload.apiTab;
    },
    handleApiTabChange: (state, action) => {
      const { apiTab, updatedFilters } = action.payload;

      state.filters = updatedFilters;

      state.apiTab = apiTab;
    },
    resetToInitialState: () => ({ ...initialState }),
  },
});

export const { setFilters, resetFilters, handleApiTabChange, setInitialApiTab, resetToInitialState } =
  reportingDashboardSlice.actions;

export default reportingDashboardSlice.reducer;
